import { useEffect, useState } from 'react';

import ComponentModal from '../../reusable/component-modal/component-modal.component.jsx';
import FulfillmentDisplay from '../fulfillment-display/fulfillment-display.component.jsx';
import FulfillmentsTable from '../../reusable/tables/fulfillments-table/fulfillments-table.component.jsx';
import Spinner from '../../reusable/spinner/spinner.component.jsx';
import UpdateFulfillment from '../update-fulfillment/update-fulfillment.component.jsx';

import Client from '../../../tools/client.js';

import {
    ContentContainer,
    MainContainer
} from '../../../styles/component.styles.jsx';

const client = new Client();

const FulfillmentWrapper = ({ orderId, getOrder }) => {
    const [ loading, setLoading ] = useState(true);
    const [ showFulfillmentDisplay, setShowFulfillmentDisplay ] = useState(false);
    const [ showUpdate, setShowUpdate ] = useState(false);
    const [ fulfillments, setFulfillments ] = useState([]);
    const [ fulfillment, setFulfillment ] = useState({});

    useEffect(() => {
        getFulfillmentsForOrder();
    }, []);

    const getFulfillmentsForOrder = async () => {
        setLoading(true);
        const res = await client.getFulfillmentsForOrder(orderId);

        setFulfillments(res);
        setLoading(false);
    }

    const getFulfillmentById = async (id) => {
        setLoading(true);
        const res = await client.getFulfillmentById(id);

        setFulfillment(res);
        setShowFulfillmentDisplay(true);
        setLoading(false);
    }

    const afterDeleteFulfillment = async () => {
        setShowUpdate(false);
        setShowFulfillmentDisplay(false);
        await getOrder();
    }

    const currentDisplay = () => {
        if(showUpdate) {
            return (
                <UpdateFulfillment 
                    fulfillment={fulfillment} 
                    getFulfillment={(id) => getFulfillmentById(id)}
                    setShowUpdate={setShowUpdate}
                    afterDeleteFulfillment={afterDeleteFulfillment}
                />
            )
        }

        return (
            <FulfillmentDisplay 
                fulfillment={fulfillment} 
                getFulfillment={(id) => getFulfillmentById(id)}
                setShowUpdate={setShowUpdate}
            />
        )
    }

    return (
        <MainContainer>
            {loading ?
                <Spinner />
            :
                <ContentContainer>
                    <ComponentModal 
                        isOpen={showFulfillmentDisplay} 
                        onClose={() => setShowFulfillmentDisplay(false)}
                        title='Fulfillment'
                    >
                        { currentDisplay() }
                    </ComponentModal>


                    <FulfillmentsTable
                        fulfillments={fulfillments || []}
                        sortKey={''}
                        setSortKey={() => {}}
                        sortDirection={''}
                        setSortDirection={() => {}}
                        reloadTable={getFulfillmentsForOrder}
                        navigateToFulfillment={(id) => getFulfillmentById(id)}
                    />    
                </ContentContainer>
            }

        </MainContainer>
    )
}

export default FulfillmentWrapper;